module.exports = __webpack_public_path__ + "img/multiple-actions-refresh.620d5cfd.svg";